import type { Dispatch, RefObject, SetStateAction } from 'react';
import { calculateNewPositioning } from './calculateNewPositioning';
import type { TooltipProps } from '../TooltipProps';

export const toggleTooltip =
  ({
    tooltipContentRef,
    setPositioningTooltip,
    variant,
    positioning,
  }: {
    tooltipContentRef: RefObject<HTMLSpanElement | null>;
    setPositioningTooltip: Dispatch<SetStateAction<TooltipProps['positioning'] | undefined>>;
    variant?: 'inline' | 'default';
    positioning?: TooltipProps['positioning'];
  }) =>
  () => {
    // toggle tooltip visibility before setting the new positioning -> the calculation needs a visible tooltip
    if (tooltipContentRef.current) {
      // eslint-disable-next-line no-param-reassign
      tooltipContentRef.current.hidden = !tooltipContentRef.current.hidden;
    }
    setPositioningTooltip((prevPositioning) => {
      // just reset the positioning to undefined if the tooltip has a position currently assigned
      if (prevPositioning) {
        return undefined;
      }
      return calculateNewPositioning(
        tooltipContentRef,
        prevPositioning ??
          // in inline variant the tooltip should always be benath the text
          (variant === 'inline' ? 'top-start' : positioning) ??
          'top-start',
      );
    });
  };
